module.exports = __webpack_public_path__ + "static/media/application.6b91bfdd.svg";